import { useState } from "react";
import { Box, Button, CircularProgress, Fade, Modal, TextField, Tooltip, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { NewQueryPopupStyle } from "./css";

// Exported so ContentEditAnalysisView can reuse the list + default
export const COUNTRIES = [
  { label: "United States", gl: "us", loc_id: 2840 },
  { label: "United Kingdom", gl: "gb", loc_id: 2826 },
  { label: "India", gl: "in", loc_id: 2356 },
  { label: "Australia", gl: "au", loc_id: 2036 },
  { label: "Canada", gl: "ca", loc_id: 2124 },
  { label: "Germany", gl: "de", loc_id: 2276 },
  { label: "France", gl: "fr", loc_id: 2250 },
  { label: "Brazil", gl: "br", loc_id: 2076 },
  { label: "Japan", gl: "jp", loc_id: 2392 },
  { label: "Singapore", gl: "sg", loc_id: 2702 },
  { label: "UAE", gl: "ae", loc_id: 2784 },
  { label: "South Africa", gl: "za", loc_id: 2710 },
  { label: "Nigeria", gl: "ng", loc_id: 2566 },
  { label: "Pakistan", gl: "pk", loc_id: 2586 },
  { label: "New Zealand", gl: "nz", loc_id: 2554 },
  { label: "Ireland", gl: "ie", loc_id: 2372 },
];

function NewQueryPopup({ open, handleClose, createQuery, handleNewQueryLoader }) {
  const [loading, setLoading] = useState(false);
  const [queryName, setQueryName] = useState("");

  const handleClick = () => {
    setLoading(true);
    createQuery(queryName);
    handleNewQueryLoader(true);
  };

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <NewQueryPopupStyle>
          <Button className="closeBtn" onClick={handleClose}>
            <CancelIcon />
          </Button>

          <Box className="HeadContentWrapper">
            <Box className="ContentWrapper">
              <Typography component="h2">Content writer - new query</Typography>
            </Box>
          </Box>

          <Box className="BodyContentWrapper">
            <Box className="FormWrapper">
              {loading ? (
                <Typography component="p" className="LoaderText">
                  Please wait while we are creating your query
                  <CircularProgress className="LoaderWrapper" size={24} />
                </Typography>
              ) : (
                <>
                  <Box className="FieldBlock">
                    <Box className="FieldLabelRow">
                      <Typography className="FieldLabel">Target keyword or topic</Typography>
                      <Tooltip
                        title="Enter the keyword or topic you want to rank for. We'll fetch live Google SERP results and analyse your top competitors."
                        placement="right"
                        arrow
                      >
                        <InfoOutlinedIcon className="TooltipIcon" />
                      </Tooltip>
                    </Box>
                    <TextField value={queryName} onChange={e => setQueryName(e.target.value)} placeholder="e.g. best CRM software for startups" variant="outlined" fullWidth />
                  </Box>

                  <Button
                    className="StartBtn"
                    onClick={handleClick}
                    disabled={loading || !queryName.trim()}
                    sx={{
                      opacity: loading || !queryName.trim() ? 0.4 : 1,
                      transition: "opacity 0.3s",
                      "&.Mui-disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                    }}
                  >
                    <AutoFixHighIcon sx={{ fontSize: 18 }} /> Start
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </NewQueryPopupStyle>
      </Fade>
    </Modal>
  );
}

export default NewQueryPopup;
